import { render, staticRenderFns } from "./BaseLogoWave.vue?vue&type=template&id=6d95fcec&scoped=true&"
import script from "./BaseLogoWave.vue?vue&type=script&lang=js&"
export * from "./BaseLogoWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95fcec",
  null
  
)

export default component.exports